import {ApolloLink} from 'apollo-link';

const logLink = new ApolloLink( ( operation, forward ) => {
    console.warn( `[request] ${operation.operationName}` );
    return forward( operation ).map( ( response ) => {
        console.warn( `[response] ${operation.operationName}`, response );
        return response;
    } )
} );

export default logLink;
